
import './Tasks.css';
import UrgencyWidget from './UrgencyWidget.js';
import React, {useState} from "react";
import updateUserData from '../../assets/functions/updateUserData'
import PopUpButton from '../../assets/components/PopUpButton.js';

function Task(props) {
    const [showPopUpButton, setShowPopUpButton] = useState(false)

    function deleteUserData() {
        updateUserData("deleteTask", props.task, props.userProfile, props.setUserProfile, props.setShowAddTask)
        setShowPopUpButton(false)
    }

    function changeTaskStatus(newStatus) {
        let placeholderTask = {...props.task}
        placeholderTask.status=newStatus
        let placeholderTaskList=[...props.tasks]
        placeholderTaskList[props.index]=placeholderTask
        updateUserData("updateTask", placeholderTaskList, props.userProfile, props.setUserProfile, props.setShowAddTask)
    }

    function getBackgroundColorCode(goalTag) {
        let matchingProjects = props.userProfile.projects.filter(project => project.shortName === goalTag)
        let projectColor = '#FFFFFF'
        if (matchingProjects.length>0) {
            projectColor=matchingProjects[0].backgroundColor;
        }
        return projectColor
    }

    return (
        <div className={(props.smallTask ? "taskBox smallTaskBox" : "taskBox")}>
            {showPopUpButton && 
                <PopUpButton taskDescription={props.task.description} deleteUserData={deleteUserData} setShowPopUpButton={setShowPopUpButton}/>
            }
        <div className="taskFlex">
            <p className="taskNumber">{props.task.id? props.task.id.slice(0,2) : 0}</p>
            <p className="taskDescription"> {props.task.description + (props.task.associatedMilestone.length>0 ? (" for " + props.task.associatedMilestone) : "")} </p>
            { props.userProfile.projects !== undefined && props.userProfile.projects.length>0 && !props.task.glowTask &&
                <div style={{"backgroundColor": getBackgroundColorCode(props.task.goalTag)}} className={"taskTag"}>
                    <p className="taskTagText">{props.task.goalTag}</p>
                </div>
            }
            { props.task.glowTask &&
                <div className={"taskTag taskTag5" }>
                    <p className="taskTagText">glow</p>
                </div>
            }
        </div>
        <div className="taskFlex">
            <div className="urgencyWidgetPlacement">
            <UrgencyWidget taskUrgency={props.task.urgency}/>
            </div>
            {props.task.timeConstraintTime!=="" &&
            <div className="taskTimeLength">
            <p className="taskTimeText">~ {props.task.timeConstraintTime} minute task</p>
            </div>
}
        <p className="taskCategory">{props.task.category}</p>
        </div>
        <div className="row bottomTaskRow">
            <p className="deleteTaskButton" onClick={() => setShowPopUpButton(true)}> x </p>
            {props.task.status === "inProgress" && !props.smallTask && 
            <p onClick={() => changeTaskStatus("notStarted")} className="bumpTaskButton"> do later</p>
        }
        </div>
        {(props.task.status === null || props.task.status === "notStarted") && 
            <p onClick={() => changeTaskStatus("inProgress")} className={props.smallTask ? "completeTaskButton smallCompleteTaskButton powerButton" : "completeTaskButton powerButton"}> mark in progress</p>
        }
        {props.task.status === "inProgress" && 
            <p onClick={() => changeTaskStatus("completed")} className={props.smallTask ? "completeTaskButton smallCompleteTaskButton powerButton" : "completeTaskButton powerButton"}> mark completed</p>
        }
        {props.task.status === "completed" && 
            <p onClick={() => changeTaskStatus("notStarted")} className={props.smallTask ? "completeTaskButton smallCompleteTaskButton powerButton" : "completeTaskButton powerButton"}> mark incomplete</p>
        }
    </div>
    )
}

export default Task;